const setMenuCurrentPage = (payload) => {
    return {
        type: 'SET_MENU_PAGE',
        payload
    }
}

const showMenu = (payload) => {
    return {
        type: 'SHOW_MENU',
        payload
    }
}

const enableNextButton = (payload) => {
    return {
        type: 'ENABLE_NEXT_BUTTON',
        payload
    }
}

const setLoading = (payload) => {
    return {
        type: 'SET_LOADING',
        payload
    }
}



export default { showMenu,setMenuCurrentPage,setLoading, enableNextButton };